

















import { Component, Mixins, Prop } from "vue-property-decorator";
import { MainMenu } from "./menu";
import { DeveloperPresentableMixin } from "../../base/components/developer/mixins";

@Component({
  components: {
    mainMenu: MainMenu,
  }
})
export default class ErrorView extends Mixins(DeveloperPresentableMixin) {
  @Prop()
  url: string;

  @Prop()
  message: string;

  created(): void {
    console.error("エラーによって処理を中断しました。");
    console.error(this.url);
    console.error(this.message);
  }
}
